import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    let cancelled = false;
    const poll = async () => {
      if (cancelled || attempts >= 10) {
        if (!cancelled && attempts >= 10) setStatus("timeout");
        return;
      }
      attempts++;
      try {
        const { data: d } = await api.get(`/checkout/status/${sessionId}`);
        setData(d);
        if (d.payment_status === "paid") setStatus("success");
        else if (d.status === "expired") setStatus("expired");
        else setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border border-ink/10 rounded-md p-8 text-center">
        {status === "checking" && (
          <>
            <Loader2 className="h-12 w-12 text-primary mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-medium text-2xl text-ink mb-2">Vérification du paiement...</h1>
            <p className="text-muted-foreground text-sm">Veuillez patienter.</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="h-16 w-16 bg-trust-light rounded-full mx-auto grid place-items-center mb-4">
              <CheckCircle2 className="h-8 w-8 text-trust" />
            </div>
            <h1 data-testid="checkout-success-title" className="font-heading font-light tracking-editorial text-3xl text-ink mb-2">Paiement confirmé</h1>
            <p data-testid="checkout-success-amount" className="text-muted-foreground mb-2">Montant : {((data?.amount_total || 0) / 100).toLocaleString("fr-FR", { style: "currency", currency: (data?.currency || "eur").toUpperCase() })}</p>
            <p className="text-sm text-muted-foreground mb-6">Votre réservation a été confirmée. Vous pouvez la consulter dans votre tableau de bord.</p>
            <Link to="/dashboard"><Button className="bg-ink hover:bg-ink/85 text-cream rounded-none">Mon tableau de bord</Button></Link>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
            <h1 className="font-heading font-medium text-2xl text-ink mb-2">Session expirée</h1>
            <p className="text-muted-foreground text-sm mb-6">Le paiement n'a pas pu être confirmé. Réessayez depuis l'événement.</p>
            <Link to="/events"><Button variant="outline">Retour aux événements</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
